<template>
    <div class="login-modal-backdrop">
        <div class="login-modal-warp" id="id-need-up">
            <div class="login-modal-header">
                {{ $t("common.Retrieve_password") }}
                <div
                    class="close-btn ico ico-btn-close"
                    @click="closeSelf()"
                ></div>
            </div>
            <div class="login-modal-body-warp">
                <div :style="'height:0.5rem'"></div>
                <UserName ref="account" @check-event="checkState()"></UserName>
                <div :style="'height:0.5rem'"></div>

                <OTP
                    ref="verify"
                    @on-sendcode="onSendCode()"
                    @check-event="checkState()"
                ></OTP>
                <div :style="'height:0.5rem'"></div>
                <Password ref="password" @check-event="checkState()"></Password>
                <div :style="'height:0.5rem'"></div>
                <div
                    :class="{
                        'login-modal-btn-red': isCanLogin,
                        'login-modal-btn-gray': !isCanLogin,
                    }"
                    @click="findPassword()"
                >
                    {{ $t("common.Confirm") }}
                </div>
            </div>
        </div>
        <MessageBox
            v-if="isShowMessageBox"
            :hasBtn="1"
            :title="$t('common.Message')"
            :body="$t('tips.password_has_been_reset_successfully')"
            :confirmText="$t('common.Confirm')"
            @on-confirm="closeSelf()"
        ></MessageBox>
    </div>
</template>
<script>
import UserName from "../common/input_user_name";
import Password from "../common/input_user_password";
import OTP from "../common/input_user_otp";
import MessageBox from "../common/modal_message_box";
import ServerManager from "../../interface/server";
import tools from "../../utils/fun";
import eventConfig from "../../baseConfig/eventConfig";
export default {
    name: "retrieve",
    components: {
        UserName,
        Password,
        OTP,
        MessageBox,
    },
    props: {},
    data() {
        return {
            isShowMessageBox: false,
            isCanLogin: false,
        };
    },
    methods: {
        checkState() {
            console.log("checkState");
            this.isCanLogin = false;
            this.$refs.password.checkPassword();
            this.$refs.account.checkAccount();
            this.$refs.verify.checkCode();
            if (
                !this.$refs.password.$data.isOk ||
                !this.$refs.account.$data.isOk ||
                !this.$refs.verify.$data.isOk
            ) {
                return;
            }
            this.isCanLogin = true;
        },
        closeSelf() {
            tools.emit(eventConfig.playEffect, "pop");
            this.$emit("on-close");
        },
        OK() {
            this.$emit("on-ok");
        },
        findPassword() {
            this.$refs.password.checkPassword();
            this.$refs.account.checkAccount();
            this.$refs.verify.checkCode();
            if (
                !this.$refs.password.$data.isOk ||
                !this.$refs.account.$data.isOk ||
                !this.$refs.verify.$data.isOk
            ) {
                return;
            }
            this.userName = this.$refs.account.$data.userName;
            this.userName = this.userName.trim();
            tools.setLoadingState(true);
            ServerManager.CheckAccount(
                this,
                this.userName,
                (data) => {
                    tools.setLoadingState(false);
                    console.log(data);
                    if (data.result == 1) {
                        if (data.data == 1) {
                            this.checkCode();
                        } else {
                            this.$refs.account.showError(
                                this.$t("tips.The_email_not_registered_yet")
                            );
                        }
                    } else {
                        this.$refs.account.showError(
                            this.$t("tips.Invalid_email_address")
                        );
                    }
                },
                () => {
                    tools.setLoadingState(false);
                    //this.$refs.account.showError("Invalid email address");
                }
            );
        },
        onSendCode() {
            this.$refs.account.checkAccount();
            if (!this.$refs.account.$data.isOk) {
                return;
            }
            this.userName = this.$refs.account.$data.userName;
            this.userName = this.userName.trim();
            tools.setLoadingState(true);

            ServerManager.CheckAccount(
                this,
                this.userName,
                (data) => {
                    tools.setLoadingState(false);
                    console.log(data);
                    if (data.result == 1) {
                        if (data.data == 1) {
                            ServerManager.sendEmailCode(
                                this,
                                this.userName,
                                "in",
                                (data) => {
                                    tools.setLoadingState(false);
                                    console.log(data);
                                    this.$refs.verify.startTime();
                                },
                                (errcode) => {
                                    tools.setLoadingState(false);
                                },
                                2
                            );
                        } else {
                            this.$refs.account.showError(
                                this.$t("tips.The_email_not_registered_yet")
                            );
                        }
                    } else {
                        this.$refs.account.showError(
                            this.$t("tips.Invalid_email_address")
                        );
                    }
                },
                () => {
                    tools.setLoadingState(false);
                    //this.$refs.account.showError("Invalid email address");
                }
            );
        },
        retrieve(codeReference) {
            this.password = this.$refs.password.$data.password;
            this.userName = this.$refs.account.$data.userName;
            this.cacheCodeReference = codeReference;
            tools.setLoadingState(true);
            ServerManager.findPassword(
                this,
                this.userName,
                this.password,
                "in",
                codeReference,
                (data) => {
                    tools.setLoadingState(false);
                    this.isShowMessageBox = true;
                },
                (err) => {
                    tools.setLoadingState(false);
                }
            );
        },

        checkCode() {
            this.userCode = this.$refs.verify.$data.code;
            tools.setLoadingState(true);
            ServerManager.checkEmailCode(
                this,
                this.userName,
                "in",
                this.userCode,
                (codeReference) => {
                    tools.setLoadingState(false);
                    this.retrieve(codeReference);
                },
                (errcode) => {
                    tools.setLoadingState(false);
                },
                2
            );
        },
    },
};
</script>

<style >
@import "../../assets/spritesmith-generated/home.css";
@import "../../assets/css/login.css";
</style>



// WEBPACK FOOTER //
// src/components/login/rummy_retrieve.vue